var exports = {
  "kL": "WebhookListItem.module__container___QUhVQU",
  "aY": "WebhookListItem.module__headerButton___QUhVQU",
  "kb": "WebhookListItem.module__left___QUhVQU",
  "Jb": "WebhookListItem.module__avatarLarge___QUhVQU",
  "fI": "WebhookListItem.module__textBlock___QUhVQU",
  "$": "WebhookListItem.module__titleRow___QUhVQU",
  "UU": "WebhookListItem.module__name___QUhVQU",
  "ML": "WebhookListItem.module__channelTag___QUhVQU",
  "KW": "WebhookListItem.module__metaRow___QUhVQU",
  "K9": "WebhookListItem.module__channelTagMobile___QUhVQU",
  "ai": "WebhookListItem.module__chevron___QUhVQU",
  "hg": "WebhookListItem.module__chevronExpanded___QUhVQU",
  "zH": "WebhookListItem.module__details___QUhVQU",
  "J1": "WebhookListItem.module__detailsRow___QUhVQU",
  "Mc": "WebhookListItem.module__avatarColumn___QUhVQU",
  "Pf": "WebhookListItem.module__label___QUhVQU",
  "_Q": "WebhookListItem.module__avatarPreview___QUhVQU",
  "OA": "WebhookListItem.module__fields___QUhVQU",
  "EN": "WebhookListItem.module__fieldsRow___QUhVQU",
  "ch": "WebhookListItem.module__fieldGrow___QUhVQU",
  "o1": "WebhookListItem.module__actions___QUhVQU",
  "Dy": "WebhookListItem.module__avatarActions___QUhVQU",
  "B": "WebhookListItem.module__urlWrapper___QUhVQU",
  "UQ": "WebhookListItem.module__monoInput___QUhVQU",
  "Bx": "WebhookListItem.module__iconSmall___QUhVQU",
  "xv": "WebhookListItem.module__truncate___QUhVQU",
};

module.exports = exports;
